import { MatPaginatorIntl } from '@angular/material/paginator';
import {Injectable} from "@angular/core";
@Injectable({providedIn: 'root'})
export class CustomPaginatorIntl extends MatPaginatorIntl {
    override itemsPerPageLabel: string = 'Elemente pro Seite:';
    override nextPageLabel: string = 'Nächste Seite';
    override previousPageLabel: string = 'Vorherige Seite';
    override firstPageLabel: string = 'Erste Seite';
    override lastPageLabel: string = 'Letzte Seite';

    override getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length === 0 || pageSize === 0) {
            return `0 von ${length}`;
        }
        const startIndex = page * pageSize;
        const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
        return `${startIndex + 1} - ${endIndex} von ${length}`;
    }
}
